export const error = (message?: any, ...optionalParams: any[]) => {
  /* eslint-disable no-console */
  console.error(message, ...optionalParams)
}
